// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-item-left-solid';

export const Component = () => (
  <path d='M19.152 10.818H5.406c-.431 0-.766-.144-1.005-.431a1.408 1.408 0 0 1-.431-1.054V5.405c0-.43.143-.766.43-1.053.24-.24.576-.383 1.006-.383h13.746c.43 0 .766.143 1.053.383.288.287.432.622.432 1.053v3.928c0 .431-.144.766-.432 1.054a1.408 1.408 0 0 1-1.053.431Zm5.411 8.334v-3.928c0-.431-.143-.766-.431-1.054a1.408 1.408 0 0 0-1.054-.43H5.405c-.43 0-.766.143-1.005.43a1.408 1.408 0 0 0-.431 1.054v3.928c0 .43.143.766.431 1.053.24.288.575.432 1.005.432h17.673c.431 0 .767-.144 1.054-.432.288-.287.431-.622.431-1.053ZM1.48 1c-.336 0-.48.144-.48.479v21.6c0 .335.144.479.479.479.335 0 .526-.144.526-.48v-21.6c0-.334-.19-.478-.526-.478Z' />
);

export const viewBox = '0 0 25 25';
